import React from "react";

const FirstPlace = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="_1-medal"
    width="72"
    height="72.002"
    className="medals first-place"
    viewBox="0 0 72 72.002"
    aria-label="gold medal position">
    <defs />
    <g id="Mask_Group_271" transform="translate(-3277.262 473.191)">
      <g id="Group_8992">
        <g id="Group_8990">
          <path
            id="Path_15197"
            d="M3306.859-449.83h16.31l18.841-23.361h-16.31z"
            className="cls-1"
          />
          <path
            id="Path_15198"
            d="M3331.255-473.191l-18.841 23.36h5.2l18.841-23.36"
            className="cls-2"
          />
        </g>
        <path
          id="Path_15199"
          d="M3323.648-454.758H3300.4v13.894h4.939v-8.954h18.3v8.954h4.939v-13.894z"
          className="cls-3"
        />
        <circle
          id="Ellipse_1689"
          cx="20.414"
          cy="20.414"
          r="20.414"
          className="cls-3"
          transform="translate(3294.082 -448.091)"
        />
        <g id="Group_8991">
          <path
            id="Path_15200"
            d="M3322.567-449.83h-16.31l-18.841-23.361h16.31z"
            className="cls-1"
          />
          <path
            id="Path_15201"
            d="M3298.171-473.191l18.84 23.36h-5.2l-18.84-23.36"
            className="cls-2"
          />
        </g>
        <circle
          id="Ellipse_1690"
          cx="15.698"
          cy="15.698"
          r="15.698"
          fill="#db8c18"
          transform="translate(3298.798 -443.375)"
        />
        <g id="_1" className="cls-5">
          <g id="Group_9221" className="cls-5">
            <path
              id="Path_15246"
              d="M3316.727-420.645h-3.246v-12.51l-3.875 1.2v-2.64l6.773-2.426h.348z"
              className="cls-3"
            />
          </g>
        </g>
      </g>
    </g>
    <path
      id="Rectangle_5640"
      fill="none"
      d="M0 0H72V72H0z"
      transform="translate(0 0.002)"
    />
  </svg>
);

export default FirstPlace;
